import type { TableData } from './types'

import { measureTables, getCorrectTable, clearTables } from './measure-tables'
import { getHeaderOffset, getScrollingPosition } from './utils'

let currentTable: TableData | null = null
let hideSamepageHeader: boolean
const eventListenerRemovers: Array<() => void> = []

const moveHeader = (
  tableObject: TableData | null,
  scrollableElement: Element | Window
): void => {
  if (!tableObject) {
    return
  }

  if (getScrollingPosition(scrollableElement) < tableObject.headerTopOriginal) {
    tableObject.header.style.transform = ''
    return
  }

  const header = tableObject.header

  const translate = `translateY(${
    getScrollingPosition(scrollableElement) -
    tableObject.headerTopOriginal +
    getHeaderOffset()
  }px)`
  header.style.transform = translate
}

const setStyle = (tableObject: TableData | null): void => {
  if (!tableObject) {
    return
  }
  tableObject.header.style.position = 'relative'
  tableObject.header.style.backgroundColor = 'white'
  tableObject.header.style.zIndex = tableObject.table.style.zIndex + '2'
  tableObject.table.style.borderCollapse = 'separate'
  tableObject.table.style.borderSpacing = '0px'
}

const removeStyle = (tableObject: TableData | null): void => {
  if (!tableObject) {
    return
  }
  tableObject.header.style.backgroundColor = 'white'
  tableObject.header.style.transform = ''
  tableObject.table.style.borderCollapse = 'collapse'
  tableObject.table.style.borderSpacing = '0px'
}

const scrollHandler = (element: Element | Window) => (): void => {
  const newTable = getCorrectTable(element, hideSamepageHeader)
  if (currentTable !== newTable) {
    removeStyle(currentTable)
    setStyle(newTable)
  }
  if (newTable) {
    moveHeader(newTable, element)
  }
  currentTable = newTable
}

export default (): void => {
  window.onDomLoad(() => {
    const hasRepeatedHeaders = !!document.querySelectorAll(
      '.usr-repeated-header'
    ).length

    if (!hasRepeatedHeaders) {
      return
    }

    hideSamepageHeader = !!document.querySelector('.usr-hide-samepage-header')

    if (hideSamepageHeader) {
      //GIVEN we have `.usr-hide-samepage-header` on the page.
      //THEN all headers should have it except 1
      const elements = document.querySelectorAll(
        '.usr-repeated-header:not(.usr-hide-samepage-header)'
      )
      if (elements.length !== 1) {
        return
      }
    }

    teardown()

    const scrollableElement =
      document.querySelector('.main-content__scroll-container') ?? window

    window.requestAnimationFrame(() => {
      measureTables(scrollableElement)
    })

    const scrollHandlerInstance = scrollHandler(scrollableElement)

    scrollableElement.addEventListener('scroll', scrollHandlerInstance, {
      passive: true,
    })

    eventListenerRemovers.push(() => {
      scrollableElement.removeEventListener('scroll', scrollHandlerInstance)
    })
  })
}

const teardown = (): void => {
  eventListenerRemovers.forEach((remover: () => void) => remover())
  clearTables()
}
